import React from 'react';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/pages/Home';
import Contacts from './components/pages/Contacts';
import InventoryDemo from './components/pages/InventoryDemo';

export default function App() {
  return <Router>
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contacts" element={<Contacts />} />
      <Route path="/pottery" element={<InventoryDemo category="Pottery" />} />
      <Route path="/metal" element={<InventoryDemo category="Metal Art" />} />
      <Route path="/knickknack" element={<InventoryDemo category="Knick-knacks" />} />
      <Route path="*" element={<Home />} />
    </Routes>
  </Router>;
}
